import React from "react";
import { Home, Pencil, CheckCircle2 } from "lucide-react";
import "../service.css";

const services = [
  {
    number: "01",
    title: "Custom Home Building",
    description:
      "We bring your dream home to life with personalized designs tailored to your lifestyle and preferences.",
    // Let's pass the icon class context directly in the style sheet to match our new style rule colors
    icon: <Home size={28} />,
    features: [
      "Personalized architectural design",
      "Premium quality materials",
      "Energy-efficient construction",
      "Transparent pricing and timeline",
    ],
    reverse: false,
  },
  {
    number: "02",
    title: "Design Consultation",
    description:
      "Expert guidance through every step of the design process to ensure your vision becomes reality.",
    icon: <Pencil size={28} />,
    features: [
      "3D visualization and rendering",
      "Space planning optimization",
      "Material and finish selection",
      "Budget planning and management",
    ],
    reverse: true,
  },
  {
    number: "03",
    title: "Additions",
    description:
      "A general construction business specializing in additions focuses on expanding existing residential or commercial structures.",
    icon: <Home size={28} />,
    features: [
      "Complex Scope & Permitting",
      "Existing Structure Integration",
      "On-Site Client Management",
      "Subcontractor Coordination",
    ],
    reverse: false,
  },
  {
    number: "04",
    title: "4 Seasons",
    description:
      "A 4-season room (or all-season room) is a year-round home addition engineered with continuous insulation, thermal-break framing, high-efficiency glazing (like Low-E double- or triple-pane glass), and dedicated HVAC integration",
    icon: <Home size={28} />,
    features: [
      "Foundation & Envelope",
      "HVAC & Climate Control",
      "High-Performance Glazing",
      "Electrical & Finishing",
    ],
    reverse: true,
  },
  {
    number: "05",
    title: "Exterior Building Spaces",
    description:
      "A construction business specializing in exterior spaces builds structures that bridge the gap between landscaping and traditional home additions.",
    icon: <Home size={28} />,
    features: [
      "Foundation & Engineering for Wind/Snow",
      "Material Selection & Durability",
      "Zoning, Setbacks, & HOA Rules",
      "All-Weather Commercial Features",
    ],
    reverse: false,
  },
  {
    number: "06",
    title: "Interior Remodeling",
    description:
      "This business model thrives on high volume and fast-paced schedules, transforming outdated layouts into modern, functional spaces without changing the home's exterior footprint.",
    icon: <Home size={28} />,
    features: [
      "Structural Alterations",
      "(kitchens & Baths)",
      "Precise Material Lead-Time Management",
      "Hidden Defect Allowances",
    ],
    reverse: true,
  },
];

const ServicesSection = () => {
  return (
    <section className="services-container">
      {/* Upper header title plate matching brand theme */}
      <div className="services-header">
        <span className="services-mini-tag">What We Offer</span>
        <h2>Our Services</h2>
        <p>
          Comprehensive custom home building solutions tailored to your vision
        </p>
      </div>

      <div className="services-inner-width">
        <div className="services-list">
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-row ${service.reverse ? "row-reverse" : ""}`}
            >
              {/* Visual Card Stack Column */}
              <div className="service-visual">
                <div className="card-stack">
                  <div className="stack-layer layer-1"></div>
                  <div className="stack-layer layer-2">
                    <div className="icon-box">{service.icon}</div>
                    <span className="bg-number">{service.number}</span>
                  </div>
                </div>
              </div>

              {/* Text Content Column */}
              <div className="service-text">
                <h3>{service.title}</h3>
                <p className="service-desc">{service.description}</p>
                <ul className="feature-list">
                  {service.features.map((feature, i) => (
                    <li key={i}>
                      <CheckCircle2 size={16} className="check-icon" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;